import round from './round';

function roundToTwoDecimal(unit: number): number {
	return round(unit, 2);
}

export default roundToTwoDecimal;
